import { AutoComplete } from 'primeng/autocomplete';

/**
 * Sets default values for p-autoComplete that are universally used in H1.
 */
export class HisAutoCompleteDefaults {

    /**
     * Unless otherwise specified, the following defaults are applied:
     * drop-down with force-selection enabled and displaying the "text" property
     *
     * @param autoCompleteRef reference to a p-autoComplete-component
     */
    initDefaults( autoCompleteRef: AutoComplete ) {
        if ( !autoCompleteRef ) {
            return;
        }

        if ( !autoCompleteRef.dropdown ) {
            autoCompleteRef.dropdown = true;
        }
        if ( !autoCompleteRef.forceSelection ) {
            autoCompleteRef.forceSelection = true;
        }
        if ( !autoCompleteRef.optionLabel ) {
            autoCompleteRef.optionLabel = 'text';
        }
    }

    /**
     * a dataSource may either be a url to a rest service or the class name of value entities
     *
     * @param url url
     * @return complete url
     */
    expandBackendUrl( dataSource: string ) {
        if ( !dataSource ) {
            return null;
        }

        if ( dataSource.indexOf( '/' ) > -1 ) {
            return dataSource;
        }

        return 'api/v1/cs/sys/values/' + dataSource;
    }
}
